export default {
  'common.ReLogin': '重新登錄',
  'common.ChangePassword': '修改密碼',
  'common.Logout': '登出',
  'common.LoginStatusInvalid': '登錄狀態已失效，請重新登錄！',
  'common.BackHome': '返回首頁',
  'message.HTTP_403': '抱歉，您無權訪問此頁面。',
  'message.HTTP_404': '抱歉，您訪問的頁面不存在。',
};
